export default __webpack_public_path__ + "static/media/train.b5da43c7.png";